import cookies from 'js-cookie'
import tracker from './publish'

class Tracker {
  constructor ({ map }) {
    this.customerMap = map
    let data = { ...window.inSidedData }

    data.page.url = window.location.pathname.substr(1)
    data.content.post.id = data.content.topic.id && window.location.hash
      ? window.location.hash.substr(5)
      : null

    data = this.enrichData(data)

    setTimeout(() => {
      tracker.trackEvent('pageview', data)
    })

    document.dispatchEvent(
      new window.CustomEvent('insided:track', {
        detail: this.mapData(data)
      })
    )
  }

  mapData (data) {
    if (!this.customerMap) return data

    for (const key in this.customerMap) {
      const val = this.customerMap[key]
      if (!val) continue

      let customerDataValue = data
      val.split('.').forEach(path => {
        customerDataValue = customerDataValue[path] || ''
      })
      if (!customerDataValue) continue

      data[key] = customerDataValue
    }
    return data
  }

  enrichData (data) {
    if (data.content.topic.id) {
      const topics = cookies.getJSON('topics') || []
      if (!topics.includes(data.content.topic.id)) {
        data.page.firstRender = true
        topics.push(data.content.topic.id)
        cookies.set('topics', topics.slice(-19), { expires: 2 })
      }
    }

    return data
  }
}

module.exports = options => new Tracker(options)
